<sb-popover [maxWidth]="'23rem'">
  <div class="flex items-center gap-3">
    <sb-avatar [size]="'lg'" [url]="avatarUrl" [firstName]="firstName" [lastName]="lastName" [colorSeed]="id" />
    <div class="flex flex-col gap-3 overflow-hidden">
      <div class="flex gap-1.5 text-2xl leading-5 font-bold">
        <span class="truncate" data-hj-suppress>
          @if (firstName) {
            {{ firstName }}
          }
          @if (lastName) {
            {{ lastName }}
          }
        </span>
      </div>
      <div class="flex flex-wrap gap-1.5 truncate">
        @if (location) {
          <sb-badge [color]="'grey'">
            <span class="truncate">{{ location }}</span>
          </sb-badge>
        }
        @if (department) {
          <sb-badge [color]="'grey'">
            <span class="truncate">{{ department }}</span>
          </sb-badge>
        }
        @if (team) {
          <sb-badge [color]="'grey'">
            <span class="truncate">{{ team }}</span>
          </sb-badge>
        }
      </div>
    </div>
  </div>
  @if (items.length) {
    <div class="flex flex-col gap-3 overflow-hidden rounded-md bg-surface p-4">
      @for (item of items; track item.icon) {
        <div class="flex w-full items-center font-medium">
          <sb-icon class="mr-2 shrink-0" [name]="item.icon" [size]="'lg'" />
          <span class="truncate">{{ item.label }}</span>
        </div>
      }
    </div>
  }
  @if (showProfileButton) {
    <sb-popover-footer>
      <button sb-button [color]="'secondary'" (click)="viewProfile.emit()">
        {{ 'View profile' | translate }}
      </button>
    </sb-popover-footer>
  }
</sb-popover>
